module.exports = __webpack_public_path__ + "img/DragonKnight.56aa8c7a.png";